export default {
  my_points: 'Meine Punkte',
  loyalty_points: 'Loyalty Punkte',
  already_have_points: 'Hast du bereits Punkte?',
  log_in: 'Log in',
  description: '🔥 Verdiene {{percentage}}p pro {{amount}} Ausgaben',
};
